import { Suspense, type FunctionComponent } from 'react';

import {
  ChunkLoadErrorBoundary,
  ErrorBoundary,
} from '@trello/error-boundaries';
import { useLazyComponent } from '@trello/use-lazy-component';

import type { InviteToJiraModalProps } from './InviteToJiraModal';

export const LazyInviteToJiraModal: FunctionComponent<
  InviteToJiraModalProps
> = (props) => {
  const InviteToJiraModal = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "invite-to-jira-modal" */ './InviteToJiraModal'
      ),
    { namedImport: 'InviteToJiraModal' },
  );

  return (
    <ErrorBoundary
      tags={{
        ownershipArea: 'trello-ghost',
        feature: 'Invite to Jira',
      }}
    >
      <ChunkLoadErrorBoundary fallback={null}>
        <Suspense fallback={null}>
          <InviteToJiraModal {...props} />
        </Suspense>
      </ChunkLoadErrorBoundary>
    </ErrorBoundary>
  );
};
